export default __webpack_public_path__ + "static/1131-d7bbf83b651803cb1f0878b8cf5c159b.gif";